import {Space, Switch, Tag, Typography} from "antd";
import {useState} from "react";
import {useQueryClient} from "@tanstack/react-query";
import {useGetProfileContext} from "../../../context/profile/profile-context";
import {LEGACY_PROFILE_QUERY_KEY} from "../../../features/profile/hooks/useProfile";
import {RecoveryCodesModal} from "./RecoveryCodesModal";
import {RegenerateCodesModal} from "./RegenerateCodesModal";
import {TotpSetupDrawer} from "./TotpSetupDrawer";
import {TwoFactorDisableModal} from "./TwoFactorDisableModal";
import {TwoFactorSetupModal} from "./TwoFactorSetupModal";

const {Text} = Typography;

export function TwoFactorSection() {
  const {state: profileState} = useGetProfileContext();
  const queryClient = useQueryClient();
  const twoFactorMethod = profileState.profileData.twoFactorMethod ?? null;
  const twoFactorEnabled = !!twoFactorMethod;

  const [isSetupModalVisible, setIsSetupModalVisible] = useState(false);
  const [isDisableModalVisible, setIsDisableModalVisible] = useState(false);
  const [isRegenerateModalVisible, setIsRegenerateModalVisible] = useState(false);
  const [isDrawerVisible, setIsDrawerVisible] = useState(false);
  const [isCodesModalVisible, setIsCodesModalVisible] = useState(false);
  const [totpData, setTotpData] = useState<{qrUri: string; secret: string} | null>(null);
  const [backupCodes, setBackupCodes] = useState<string[]>([]);

  const handleToggle = (checked: boolean) => {
    if (checked) {
      setIsSetupModalVisible(true);
    } else {
      setIsDisableModalVisible(true);
    }
  };

  return (
    <Space direction="vertical" size={8} style={{display: "flex"}}>
      <Space
        style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}
      >
        <Space size={8}>
          <Text strong>Two-factor authentication</Text>
          <Tag color={twoFactorEnabled ? "green" : "default"}>
            {twoFactorEnabled ? "Enabled" : "Disabled"}
          </Tag>
        </Space>
        <Switch checked={twoFactorEnabled} onChange={handleToggle} />
      </Space>
      <Text type="secondary" style={{fontSize: 13}}>
        Enable two-factor authentication to protect your account from unauthorised access
      </Text>
      {twoFactorEnabled && twoFactorMethod === "totp" && (
        <Text
          style={{fontSize: 13, textDecoration: "underline", cursor: "pointer"}}
          onClick={() => setIsRegenerateModalVisible(true)}
        >
          Regenerate recovery codes
        </Text>
      )}

      <TwoFactorSetupModal
        visible={isSetupModalVisible}
        onClose={() => setIsSetupModalVisible(false)}
        onTotpInitiated={(data) => {
          setTotpData(data);
          setIsDrawerVisible(true);
        }}
        onEmailSetupSuccess={() => setIsSetupModalVisible(false)}
      />
      <TotpSetupDrawer
        visible={isDrawerVisible}
        qrUri={totpData?.qrUri}
        secret={totpData?.secret}
        onClose={() => setIsDrawerVisible(false)}
        onSuccess={(codes) => {
          setIsDrawerVisible(false);
          setIsSetupModalVisible(false);
          setBackupCodes(codes);
          setIsCodesModalVisible(true);
        }}
      />
      <RecoveryCodesModal
        visible={isCodesModalVisible}
        codes={backupCodes}
        onClose={() => {
          setIsCodesModalVisible(false);
          queryClient.invalidateQueries({queryKey: [LEGACY_PROFILE_QUERY_KEY]});
        }}
      />
      <TwoFactorDisableModal
        visible={isDisableModalVisible}
        method={twoFactorMethod ?? "email"}
        onClose={() => setIsDisableModalVisible(false)}
        onSuccess={() => setIsDisableModalVisible(false)}
      />
      <RegenerateCodesModal
        visible={isRegenerateModalVisible}
        onClose={() => setIsRegenerateModalVisible(false)}
      />
    </Space>
  );
}
